import React, {useId} from 'react';
import {OverlayTrigger, Popover} from 'react-bootstrap';

export default function HelpPopover (props) {
  const { children, title = 'Info', placement = 'right' } = props;
  const id = useId();
  return (
    <OverlayTrigger
      placement={placement}
      trigger={['hover', 'focus']}
      delay={{ show: 150, hide: 200 }}
      overlay={(
        <Popover id={id} title={title} style={{maxWidth: 640}}>
          {children}
        </Popover>
      )}
    >
      <span style={{cursor: 'help'}}><i className="icon mdi mdi-help"></i></span>
    </OverlayTrigger>
  );
}


